import { useState } from "react";
import useFirebaseAuth from "../common/useFirebaseAuth";
import useAccountVerifier from "./useAccountVerifier";
import useFirestore from "../common/useFirestore";
import useCrypto from "../common/useCrypto";
import { useNavigate } from "react-router-dom";

function useRegister(){
    const navigate = useNavigate();
    const {createAccount, authGetPhoneCode, authSendPhoneCode} = useFirebaseAuth();
    const {writeFirestore, readFirestoreOneDoc} = useFirestore();
    const {encrypto} = useCrypto();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [modal, setModal] = useState({
        title:"",
        content:"",
        onConfirmClickHandler:() => {}
    })
    const [inputAuthorizationCode, setInputAuthorizationCode] = useState("");
    const [isOpenAuthorizationInput, setIsOpenAuthorizationInput] = useState(false);
    const {accountFormatValidationHandler, accountRegisterPreVerifier} = useAccountVerifier();
    const [inputDescriptions, setInputDescriptions] = useState({
        name:"",
        tel:"",
        id:"",
        password:"",
        password_re:""
    });
    const [inputs, setInputs] = useState({
        name:"",
        tel:"",
        id:"",
        password:"",
        password_re:""
    })

    const onInputChangeHandler = async(e) => {
        const {name, value} = e.target;

        setInputs({
            ...inputs,
            [name]:value
        })
        const error_description = await accountFormatValidationHandler(inputs, name, value);
        setInputDescriptions({
            ...inputDescriptions,
            [name]:error_description
        })
        
    }

    const onRegisterClickHandler = async() => {
        const {canLogin, description} = accountRegisterPreVerifier(inputs, inputDescriptions);
        if(canLogin){
            const create_account_result = await createAccount(inputs.id, inputs.password).then(res => {
                return res;
            })
            if(create_account_result){
                const encrypted_password = encrypto(inputs.password);
                const encrypted_tel =encrypto(inputs.tel);
                const firestore_result = await writeFirestore("Account", inputs.id, {
                    id:inputs.id,
                    password:encrypted_password,
                    name:inputs.name,
                    tel:encrypted_tel,
                    uid:create_account_result.uid,
                    admin:false,
                    state:"REGISTERED",
                    register_date:new Date()
                }).then(res => {
                    return res;
                })
                if(firestore_result){
                    setModal({
                        title:"SUCCESS",
                        content:"계정이 생성되었습니다",
                        onConfirmClickHandler:() => navigate("/login")
                    })
                    setIsOpenModal(true);
                }else{
                    setModal({
                        title:"ERROR",
                        content:"계정생성중 오류가 발생하였습니다\n오류가 계속 발생할 경우 연락바랍니다",
                        onConfirmClickHandler:() => setIsOpenModal(false)
                    })
                    setIsOpenModal(true);
                }
            }else{
                setModal({
                    title:"ERROR",
                    content:"계정생성중 오류가 발생하였습니다\n오류가 계속 발생할 경우 연락바랍니다",
                    onConfirmClickHandler:() => setIsOpenModal(false)
                })
                setIsOpenModal(true);
            }
        }else{
            setModal({
                title:"ERROR",
                content:description
            })
            setIsOpenModal(true);
        }
    }

    const onInputAuthorizationCodeChangeHandler = (e) => {
        setInputAuthorizationCode(e.target.value);
    }

    const onGetPhoneAuthorizationCodeHandler = (e) => {
        authGetPhoneCode(inputs.tel, e.target.id);
        setIsOpenAuthorizationInput(true);
    }

    const onSendPhoneAuthorizationCodeHandler = async() => {
        const result = await authSendPhoneCode(inputAuthorizationCode);
        if(result && result.uid){
            setInputDescriptions({
                ...inputDescriptions,
                "tel":"",
            })
            setIsOpenAuthorizationInput(false);
            return;
        }else{
            setInputDescriptions({
                ...inputDescriptions,
                "tel":"코드가 일치하지 않습니다",
            })
            setInputAuthorizationCode("");
        }
    }

    return{inputs, onInputChangeHandler, inputDescriptions, onRegisterClickHandler,
        isOpenModal, modal,onGetPhoneAuthorizationCodeHandler, onSendPhoneAuthorizationCodeHandler,
        inputAuthorizationCode, onInputAuthorizationCodeChangeHandler, isOpenAuthorizationInput
    }
}

export default useRegister;